import { Component, input, computed } from '@angular/core';

export type MiniProgressColor = 'blue' | 'purple' | 'emerald' | 'amber' | 'gray';

@Component({
  selector: 'lib-mini-progress',
  host: { '[class]': 'hostClass()' },
  template: `
    <div class="msa-mini-progress">
      <div class="msa-mini-progress__track">
        <div class="msa-mini-progress__fill" [style.width.%]="value()"></div>
      </div>
    </div>
  `,
  styles: [`
    :host { display: block; width: 100%; }
    .msa-mini-progress { width: 100%; }
    .msa-mini-progress__track {
      height: 6px;
      border-radius: 999px;
      background: #f3f4f6;
      overflow: hidden;
      width: 100%;
    }
    .msa-mini-progress__fill {
      height: 100%;
      border-radius: 999px;
      transition: width 200ms ease;
    }
    :host(.msa-mini-progress--blue) .msa-mini-progress__fill { background: #3b82f6; }
    :host(.msa-mini-progress--purple) .msa-mini-progress__fill { background: #a855f7; }
    :host(.msa-mini-progress--emerald) .msa-mini-progress__fill { background: #10b981; }
    :host(.msa-mini-progress--amber) .msa-mini-progress__fill { background: #fbbf24; }
    :host(.msa-mini-progress--gray) .msa-mini-progress__fill { background: #9ca3af; }
  `]
})
export class MiniProgressComponent {
  readonly value = input.required<number>();
  readonly color = input<MiniProgressColor>('blue');

  readonly hostClass = computed(() => `msa-mini-progress--${this.color()}`);
}
